import { useState, useEffect } from 'react';
import axios from 'axios';
import { Search, X } from 'lucide-react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export default function UserSearch({ onSelectUser, onClose }) {
  const [query, setQuery] = useState('');
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const searchUsers = async () => {
      setLoading(true);
      try {
        const token = localStorage.getItem('dharmbook_token');
        const response = await axios.get(`${API}/users/search/all?q=${encodeURIComponent(query)}`, {
          headers: { Authorization: `Bearer ${token}` }
        });
        setUsers(response.data);
      } catch (error) {
        console.error('Failed to search users:', error);
      } finally {
        setLoading(false);
      }
    };

    const debounce = setTimeout(searchUsers, 300);
    return () => clearTimeout(debounce);
  }, [query]);

  return (
    <div className="flex flex-col flex-1">
      {/* Search Header */}
      <div className="p-3 border-b border-gray-200">
        <div className="flex items-center gap-2">
          <div className="relative flex-1">
            <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400" />
            <input
              type="text"
              value={query}
              onChange={(e) => setQuery(e.target.value)}
              placeholder="Search devotees..."
              autoFocus
              className="w-full pl-10 pr-4 py-2 bg-gray-100 rounded-full text-sm focus:outline-none focus:ring-2 focus:ring-orange-400"
              data-testid="user-search-input"
            />
          </div>
          <button
            onClick={onClose}
            className="p-2 rounded-full hover:bg-gray-100"
            data-testid="close-search-btn"
          >
            <X className="w-5 h-5 text-gray-600" />
          </button>
        </div>
      </div>

      {/* Results */}
      <div className="flex-1 overflow-y-auto">
        {loading ? (
          <div className="flex items-center justify-center py-8">
            <div className="text-center">
              <div className="text-2xl text-[#FF9933] mb-2">ॐ</div>
              <p className="text-sm text-gray-500">Searching...</p>
            </div>
          </div>
        ) : users.length === 0 ? (
          <div className="flex items-center justify-center py-8">
            <div className="text-center">
              <p className="text-gray-500">No users found</p>
              <p className="text-sm text-gray-400 mt-1">Try a different search</p>
            </div>
          </div>
        ) : (
          users.map((user) => (
            <button
              key={user.id}
              onClick={() => onSelectUser(user.id)}
              className="w-full flex items-center gap-3 p-3 hover:bg-gray-50 transition-colors"
              data-testid={`user-result-${user.id}`}
            >
              <img
                src={user.avatar || 'https://images.unsplash.com/photo-1761383396518-e2e30968a25f?w=100&h=100&fit=crop'}
                alt={user.name}
                className="w-10 h-10 rounded-full object-cover"
              />
              <div className="text-left">
                <h3 className="font-medium text-gray-900">{user.name}</h3>
                <p className="text-xs text-gray-500 capitalize">{user.role}</p>
              </div>
            </button>
          ))
        )}
      </div>
    </div>
  );
}
